import { Button, Cascader, Checkbox, Image, Modal, Pagination, Select, Space, Tabs, Upload, message } from "antd"
import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import API, { commonApiInvoker } from "@api/api"
import { LoadingOutlined, PlusOutlined, CloseCircleFilled } from '@ant-design/icons';
import ImageItem from "../ImageItem"
import styles from "./index.module.scss"
import * as _ from "underscore";
import Utils from "@utils/utils"
import { IMAGE_TYPE, BATCH_IMAGES_TYPE } from "@utils/CONST"
import PSAIModal from "@PSAIComponents/PSAIModal";
import CustomModelForm from "@view/page/selfModelFakeLeft/CustomModelForm";
import ModelFilterSelection from "@view/page/selfModelFakeLeft/ModelFilterSelection";
import ModelFilterSelectionNew from "@view/page/selfModelFakeLeft/ModelFilterSelection_new";
import Iconfont from '@utils/Iconfont';
import { CloseOutlined } from '@ant-design/icons';
const fallback = require('@assets/images/fallback.png')

const getResourceData = (projectType) => {
    return projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? {
        func: "model",
        type: "tryOn",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? {
        func: "model",
        type: "person",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? {
        func: "model",
        type: "background",
    } : projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? {
        func: "commodity",
        type: "stacking",
    } : {}
}

const CustomPoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({}),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])
    const [force, updateForce] = useState()
    const isLoop = useRef()
    const isMounted = useRef(true)

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const loopFunc = () => {
        updateForce({})
        if (isLoop.current && isMounted.current) {
            setTimeout(() => {
                loopFunc()
            }, 2000)
        }
    }

    useEffect(() => {
        if (props.activeKey != "custom") return
        props.onChange(list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)))
    }, [props.activeKey, list])

    useEffect(() => {
        const notSucc = !!list.find(item => ("maskStatus" in item.attr ? item.attr?.maskStatus != "succeeded" : false))
        if (notSucc) {
            if (!isLoop.current) {
                isLoop.current = true
                loopFunc()
            }
        } else {
            if (isLoop.current) {
                isLoop.current = false
            }
        }
    }, [list])

    const totalRef = useRef(1)
    useEffect(() => {
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getCustomResources2({
            ...data,
            pageIndex: 1,
            pageSize: totalRef.current
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getCustomResources2({
                    ...data,
                    pageIndex: 1,
                    pageSize: totalRef.current
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                    setList(list.map(item => ({
                        ...item,
                        isFavorite: item.attr.isFavorite,
                        attr: {
                            ...item.attr,
                            custom: true
                        }
                    })))
                })
            } else {
                const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                setList(list.map(item => ({
                    ...item,
                    isFavorite: item.attr.isFavorite,
                    attr: {
                        ...item.attr,
                        custom: true
                    }
                })))
            }
        })
    }, [force])

    const [totalNum, setTotalNum] = useState(0)
    const [succNum, setSuccNum] = useState(0)
    const uploadFileWithAntispamId = (file) => {
        return Utils.checkImageIslegal(file, 1).then(res => {
            if (!res) return false
            if (!res.isLegal) {
                PSAIModal.confirm({
                    content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                    okText: '重新上传',
                    cancelText: '取消',
                    onOk() {
                        Utils.openFile().then((res) => {
                            if (res) beforeUpload(res)
                        })
                    },
                    onCancel() { },
                })
                return false
            } else {
                const { imageAntispamId, data } = res
                return {
                    url: data,
                    imageAntispamId
                }
            }
        }).catch((err) => {
            message.error(err.message)
        })
    }
    function removeExtension(filename) {
        if (filename === '.' || filename === '..') return filename;
        const lastDot = filename.lastIndexOf('.');
        if (lastDot === -1 || lastDot === 0) return filename;
        return filename.substring(0, lastDot);
    }
    const uploadDebounce = useCallback(_.debounce(async (file, fileList) => {
        if (fileList.length > 30) return message.warning("每次最多上传30张图")
        setSuccNum(0)
        setTotalNum(fileList.length)
        setLoading(true)
        for (let file of fileList) {
            const name = removeExtension(file.name)
            // 检查文件类型和宽高比
            let isNromal = false
            if (props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                // 商品堆叠仅支持透明底
                isNromal = await Utils.validateImageFilePNG(file)
            } else {
                isNromal = await Utils.validateImageFile(file)
            }
            if (!isNromal) continue
            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message); continue; }
            file = resizeRes.file
            try {
                const res = await uploadFileWithAntispamId(file)
                if (!res) continue
                const { url, imageAntispamId } = res
                if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
                    const res2 = await API.saveCustomMaterialv2({
                        func: IMAGE_TYPE.MODEL,
                        type: 'background',
                        image: url,
                        attr: {
                            title: `${name}`,
                        }
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                } else if (props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                    const res2 = await API.saveCustomMaterialv2({
                        func: IMAGE_TYPE.COMMODITY,
                        type: 'stacking',
                        image: url,
                        attr: {
                            title: `${name}`,
                        }
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                } else {
                    const res2 = await API.saveCustomTryOnModel({
                        tryOnImage: url,
                        thumbnail: url,
                        imageAntispamId,
                        title: `${name}`,
                        async: 1
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                }
                setSuccNum(pre => pre + 1)
            } catch (err) {
                console.error(err)
            }
            updateForce({})
        }
        setLoading(false)
    }, 100), [props.projectType])
    const beforeUpload = async (file, fileList) => {
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义模特？`,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({
                    resourceIds: [record.id]
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                    if (props.value.find(item => item.key == record.name)) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    const handleFavor = (record) => {
        const data = getResourceData(props.projectType)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource({
                ...data,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            commonApiInvoker(API.favoriteResource({
                ...data,
                resourceId: record.id,
                custom: true,
            })).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }

    const modelFormRef = useRef()
    const [open, setOpen] = useState(false)
    const handleNewModel = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleNewModel())
        if (!status) return

        setOpen(true)
    }
    const handelOk = async () => {
        try {
            setLoading(true)
            const res = await modelFormRef.current.onSubmit()
            if (res) {
                message.success('模特添加成功')
                // sessionStorage.setItem('hsf_model_id', res)
                setOpen(false)
                updateForce({})
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                <div className={styles.SelectTryonPose}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ?
                            <div className={styles.UploadTriggerBatch} onClick={handleNewModel}>
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>新增模特</div>
                                </div>
                            </div> :
                            <Upload.Dragger
                                multiple
                                accept='image/jpeg,image/png,image/webp,image/avif'
                                listType="picture-card"
                                showUploadList={false}
                                className={styles.UploadWrapBatch}
                                beforeUpload={beforeUpload}
                                onDrop={handleDrop}
                                disabled={loading}
                            >
                                <div className={styles.UploadContent}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>
                                        <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap", marginBottom: 5 }}>{loading ? `已上传 ${succNum}/${totalNum}` : "点击上传"}</span>
                                        <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap" }}>最多30张/次</span>
                                    </div>
                                </div>
                            </Upload.Dragger>
                    }
                </div>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            hideCustomIcon
                            projectType={props.projectType}
                            toolGroup={
                                item.attr?.maskStatus == "failed" ? {
                                    onRemove: () => handleRemove(item)
                                } : {
                                    onFavor: () => handleFavor(item),
                                    onPreview: true,
                                    onRemove: () => handleRemove(item),
                                }
                            }
                            disabled={!("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
            <PSAIModal
                getContainer={document.body}
                title="新增模特"
                maxWidth={586}
                open={open}
                confirmLoading={loading}
                onOk={handelOk}
                onCancel={() => setOpen(false)}
            >
                <CustomModelForm ref={modelFormRef} />
            </PSAIModal>
        </>
    )
})

const FavoritePoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({})
    }))

    const [list, setList] = useState([])
    const [force, updateForce] = useState()
    useEffect(() => {
        if (props.activeKey != "favorite") return
        props.onChange(list)
    }, [props.activeKey, list])
    const totalRef = useRef(1)
    useEffect(() => {
        const params = {}
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getFavoriteResources({
            ...data,
            pageIndex: 1,
            pageSize: totalRef.current,
            ...params,
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getFavoriteResources({
                    ...data,
                    pageIndex: 1,
                    pageSize: totalRef.current,
                    ...params,
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                    setList(
                        list
                            .map(item => ({ ...item, isFavorite: true }))
                            .map(item => ({
                                ...item,
                                attr: {
                                    ...item.attr,
                                    custom: "custom" in item.attr ? item.attr.custom : item.attr.skin == "custom"
                                }
                            }))
                    )
                })
            } else {
                const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                setList(
                    list
                        .map(item => ({ ...item, isFavorite: true }))
                        .map(item => ({
                            ...item,
                            attr: {
                                ...item.attr,
                                custom: "custom" in item.attr ? item.attr.custom : item.attr.skin == "custom"
                            }
                        }))
                )
            }
        })
    }, [force])
    const handleFavor = (record) => {
        const data = getResourceData(props.projectType)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource({
                ...data,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                updateForce({})
                props.onFavor(record, false)
            })
        } else {
            commonApiInvoker(API.favoriteResource({
                ...data,
                resourceId: record.id,
                custom: !!record?.attr?.custom,
            })).then(res => {
                message.success("已收藏")
                updateForce({})
                props.onFavor(record, true)
            })
        }
    }
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义模特？`,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({
                    resourceIds: [record.id]
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                    if (props.value.find(item => item.key == record.name)) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            projectType={props.projectType}
                            toolGroup={{
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                                onRemove: () => handleRemove(item)
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

const PoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({}),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const totalRef = useRef(1)
    const [force, updateForce] = useState()
    const [list, setList] = useState([])
    useEffect(() => {
        if (props.activeKey != "default") return
        props.onChange(list)
    }, [props.activeKey, list])
    useEffect(() => {
        const params = {}
        const { sex, skin, age, shoesType, pose, clothesCate, toneTags, text } = props.filter
        if (age?.length > 0) params.age = age?.join()
        if (sex?.length > 0) params.sex = sex?.join()
        if (skin?.length > 0) params.skin = skin?.join()
        if (toneTags?.length > 0) params.toneTags = toneTags?.join()
        if (shoesType?.length > 0) params.shoesType = shoesType?.join()
        if (pose?.length > 0) params.poseType = pose?.join()
        if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
        if (text?.length > 0) params.text = text
        if (props.filter.sceneTags?.length > 0) params.sceneTags = props.filter.sceneTags?.join()
        if (props.filter.compositionTags?.length > 0) params.compositionTags = props.filter.compositionTags?.join()
        const data = getResourceData(props.projectType)
    
        commonApiInvoker(API.getPresetResources2({
            ...data,
            ...params,
            pageIndex: 1,
            pageSize: totalRef.current
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getPresetResources2({
                    ...data,
                    ...params,
                    pageIndex: 1,
                    pageSize: totalRef.current
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => (item.name != "00_random" && item.name != "00_keep" && item.name != "00_default_style"))
                    setList(list.map(item => ({
                        ...item,
                        isFavorite: item.attr.isFavorite,
                        attr: {
                            ...item.attr,
                            custom: false
                        }
                    })))
                })
            } else {
                const list = (res?.items ?? []).filter(item => (item.name != "00_random" && item.name != "00_keep" && item.name != "00_default_style"))
                setList(list.map(item => ({
                    ...item,
                    isFavorite: item.attr.isFavorite,
                    attr: {
                        ...item.attr,
                        custom: false
                    }
                })))
            }
        })
    }, [force, props.filter])
    const handleFavor = (record) => {
        const data = getResourceData(props.projectType)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource({
                ...data,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            commonApiInvoker(API.favoriteResource({
                ...data,
                resourceId: record.id,
                custom: false,
            })).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            projectType={props.projectType}
                            toolGroup={{
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

// 选择tryon模特
const SelectTryonPose = (props) => {
    // props.readOnly
    // props.value
    // props.projectType
    const { drawOpen } = props
    const [value, setValue] = useState([...props.value])
    const [activeKey, setActiveKey] = useState(props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? "custom" : "default")
    const [filter, setFilter] = useState({
        skin: [], // 肤色
        sex: [], // 性别
        age: [], // 年龄
        toneTags: [], // 气质类型
        shoesType: [], // 品类 
        pose: [], // 模特
        clothesCate: [], // 服饰品类
        text: "", // 搜索
        sceneTags: [], // 背景类别
        compositionTags: [], // 构图
    })
    const handleFilterChange = (filter) => {
        console.log(filter)
        setFilter(pre => ({ ...pre, ...filter }))
    }
    const handleClick = useCallback((record) => {
        if (props.readOnly) return
        if (value.find(item => item.key == record.name)) {
            setValue(value.filter(item => item.key != record.name))
        } else {
            const item = { key: record.name }
            item.url = record.attr?.custom ? (record.attr.tryOnImage || record.imageUrl) : record.imageUrl
            item.custom = record.attr?.custom ? 1 : 0 // 0-预设 1-自定义
            item.colorMask = record.attr?.custom ? record.attr.colorMask : null
            item.title = record.attr?.title ? record.attr.title : null
            if (props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                item.num = 1
            }
            setValue([...value, item].slice(props.maxCount == -1 ? 0 : -props.maxCount))
        }
    }, [value])

    const style = {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        alignContent: "flex-start",
        maxHeight: `calc(100vh - 180px)`,
        minHeight: `calc(100vh - 180px)`,
        gap: "10px"
    }

    const [displayList, setDisplayList] = useState([])
    const handleChange = (list) => {
        setDisplayList(list)
    }

    const handleOk = () => {
        props.onChange([...value])
        props.onClose()
    }

    const customRef = useRef()
    const defaultRef = useRef()
    const favorRef = useRef()
    const handleDeleteBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => item2.name == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const deleteRecords = displayRecords.filter(item => item.attr?.custom)
        if (deleteRecords.length == 0) return message.warning("当前页的预设模特不可删除")
        const title = displayRecords.length == deleteRecords.length ?
            `确定删除当前页选中的 ${deleteRecords.length} 张自定义模特？` :
            "确定要删除吗？"
        const content = displayRecords.length == deleteRecords.length ? "" :
            <span style={{ whiteSpace: "pre-wrap" }}>{`预设模特不可删除，仅可删除当前页选中的 ${deleteRecords.length} 张自定义模特。`}</span>
        PSAIModal.confirm({
            title: title,
            content: content,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({ resourceIds: deleteRecords.map(item => item.id) })).then(() => {
                    message.success('删除成功')
                    const otherList = value.filter(item => !deleteRecords.find(item2 => item2.name == item.key))
                    setValue([...otherList])
                    activeKey == "custom" ?
                        customRef.current?.refresh() :
                        favorRef.current?.refresh()
                })
            },
            onCancel() { },
        })
    }

    const handleUnfavorBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => item2.name == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const favorRecords = displayRecords.filter(item => item.isFavorite)
        if (favorRecords.length == 0) return message.warning("当前页没有选择已收藏的模特")
        const data = getResourceData(props.projectType)
        const resourceList = favorRecords.map(item => item.id)
        commonApiInvoker(API.unfavoriteResource({
            ...data,
            resourceId: resourceList,
        })).then(res => {
            message.success("已取消收藏")
            if (activeKey == "custom") customRef.current?.refresh()
            else if (activeKey == "default") defaultRef.current?.refresh()
            else {
                defaultRef.current?.refresh()
                favorRef.current?.refresh()
            }
        })
    }

    const handleFavor = (record, faovr) => {
        defaultRef.current?.onFavor(record, faovr)
    }

    const handleRemove = ({ key }) => {
        setValue(value.filter(item => item.key != key))
    }

    // 背景筛选
    const [modelSceneTypeOpts, setModelSceneTypeOpts] = useState([])
    const [modelCompositionTypeOpts, setModelCompositionTypeOpts] = useState([])
    useEffect(() => {
        if (props.projectType != BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return
        Promise.all([
            API.categoryList({
                func: 'background',
                category: 'sceneTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'background',
                category: 'compositionTags',
                resourceType: 'model',
            })
        ]).then(([res1, res2]) => {
            const modelSceneTypeOpts = res1.data.map((item) => {
                return {
                    label: item.display,
                    title: item.display,
                    options: item.subList.map(opt => ({
                        label: opt.display,
                        value: item.display + '/' + opt.value,
                    })),
                }
            })
            const modelCompositionTypeOpts = res2.data
            setModelSceneTypeOpts(modelSceneTypeOpts || [])
            setModelCompositionTypeOpts(modelCompositionTypeOpts || [])
        })
    }, [])

    const sceneType = (
        <>
            <Select
                placeholder="构图"
                mode="multiple"
                allowClear={true}
                size="small"
                style={{ width: 140, float: "right" }}
                onChange={(value) => handleFilterChange({ compositionTags: value })}
                options={modelCompositionTypeOpts}
            />
            <Select
                placeholder="背景类型"
                mode="multiple"
                allowClear={true}
                size="small"
                style={{ width: 140, float: "right", marginRight: '12px' }}
                onChange={(value) => handleFilterChange({ sceneTags: value })}
                options={modelSceneTypeOpts}
            />
        </>

    )
    const operations = (
        <div className={styles.OperationsBatch}>
            {
                activeKey == "default" &&
                <div style={{ width: 500 }}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ?
                            sceneType :
                            props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ?
                                <ModelFilterSelection filterValue={filter} imageType={IMAGE_TYPE.CLOTHES} isPose onChange={handleFilterChange} /> :
                                <ModelFilterSelectionNew filterValue={filter} imageType={IMAGE_TYPE.CLOTHES} onChange={handleFilterChange} />
                    }
                </div>
            }
            {/* <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <Button style={{ lineHeight: 1 }} disabled={value.length == 0} size="small" onClick={handleUnfavorBatch}>取消收藏</Button>
                {
                    activeKey != "default" &&
                    <Button style={{ lineHeight: 1 }} disabled={value.length == 0} size="small" onClick={handleDeleteBatch}>删除</Button>
                }
            </div> */}
        </div>
    )

    const selectedListRender = useMemo(() => (
        <div className={styles.SelectedListBatch}>
            {
                value.map(item => {
                    return (
                        <div key={item.key} className={styles.SelectedItem}>
                            <Image src={Utils.getImgThumbnail(item.url)} fallback={fallback} preview={false} />
                            <Iconfont onClick={() => handleRemove(item)} className={styles.Icon} type="icon-DeleteOutlined" />
                        </div>
                    )
                })
            }
        </div>
    ), [value])

    const title = useMemo(() => {
        return props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? "模特" :
            props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? "模特" :
                props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? "辅品" :
                    props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? "背景" : ""

    }, [props.projectType])

    const items = [{
        key: "default",
        label: `预设${title}`,
        children: (
            <PoseList
                maxCount={props.maxCount}
                ref={defaultRef}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                filter={filter}
            />
        ),
    }, {
        key: "custom",
        label: `自定义${title}`,
        children: (
            <CustomPoseList
                ref={customRef}
                maxCount={props.maxCount}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
            />
        ),
        destroyOnHidden: true
    }, {
        key: "favorite",
        label: "我的收藏",
        children: (
            <FavoritePoseList
                maxCount={props.maxCount}
                ref={favorRef}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                onFavor={handleFavor}
            />
        ),
        destroyOnHidden: true
    }]

    return (
        <>
            <div className={styles.SelectTryonPoseWrap}>
                <CloseOutlined className={styles.CloseIcon} onClick={() => props.setDrawOpen(false)} />
                <div className={styles.PoseLeft}>
                    <Tabs
                        size="small"
                        activeKey={activeKey}
                        tabBarExtraContent={operations}
                        items={props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? items.filter(item => item.key != "default") : items}
                        onChange={setActiveKey}
                    />
                </div>
                {
                    props.maxCount > 1 &&
                    <div className={`${styles.PoseRight} _beauty_scrollbar`}>
                        <p style={{ marginBottom: 20 }}>已选参考图 {value.length}/{props.maxCount}</p>
                        {selectedListRender}
                    </div>
                }

            </div>

            <div className={styles.FooterBatch}>
                <Button style={{ width: 200, height: 36, marginRight: 12 }} onClick={() => props.setDrawOpen(false)}>取消</Button>
                <Button style={{ width: 200, height: 36 }} type="primary" onClick={handleOk}>确定</Button>
            </div>
        </>

    )
}

export default SelectTryonPose